export enum BasketItemErrorCode {
  J0 = 'J0',
  J2 = 'J2',
  YT = 'YT',
}

// Enum key/values order are used to sort errors by priority also
export enum BasketItemErrorType {
  // block placing basket:
  JO_NOW_ERROR = 'JO_NOW_ERROR',
  J2_ERROR = 'J2_ERROR',
  YT_ERROR = 'YT_ERROR',
  ITEM_ERROR = 'ITEM_ERROR',

  // Not blocked placing basket:
  JO_FUTURE_WARNING = 'JO_FUTURE_WARNING',
  BASKET_TOTAL_ZERO = 'BASKET_TOTAL_ZERO', // for disable placed button
  BASKET_ROW_NULL_ERROR = 'BASKET_ROW_NULL_ERROR',
  BASKET_TOTAL_DIFFERENT_QUANTITIES = 'BASKET_TOTAL_DIFFERENT_QUANTITIES',
  ITEM_WARNING = 'ITEM_WARNING',
}

export enum BasketValidationType {
  Validation_Order_ErrorCode_CMI_ORDER_TOO_SMALL = 'Validation_Order_ErrorCode_CMI_ORDER_TOO_SMALL',
  Validation_Order_ErrorCode_CUSTOMER_BRAND_INACTIVE = 'Validation_Order_ErrorCode_CUSTOMER_BRAND_INACTIVE',
  Validation_Order_ErrorCode_CUSTOMER_DELETED = 'Validation_Order_ErrorCode_CUSTOMER_DELETED',
  Validation_Order_ErrorCode_CUSTOMER_DELIVERY_BLOCKED = 'Validation_Order_ErrorCode_CUSTOMER_DELIVERY_BLOCKED',
  Validation_Order_ErrorCode_CUSTOMER_DISCOUNT = 'Validation_Order_ErrorCode_CUSTOMER_DISCOUNT',
  Validation_Order_ErrorCode_CUSTOMER_INACTIVE = 'Validation_Order_ErrorCode_CUSTOMER_INACTIVE',
  Validation_Order_ErrorCode_CUSTOMER_ORDER_BLOCKED = 'Validation_Order_ErrorCode_CUSTOMER_ORDER_BLOCKED',
  Validation_Order_ErrorCode_CUSTOMER_NOT_FOUND = 'Validation_Order_ErrorCode_CUSTOMER_NOT_FOUND',
  Validation_Order_ErrorCode_CUSTOMER_VALIDATION_FAILED = 'Validation_Order_ErrorCode_CUSTOMER_VALIDATION_FAILED',
  Validation_Order_ErrorCode_DEL_DATE_PARSE_ERROR = 'Validation_Order_ErrorCode_DEL_DATE_PARSE_ERROR',
  Validation_Order_ErrorCode_EAN_NOT_FOUND = 'Validation_Order_ErrorCode_EAN_NOT_FOUND',
  Validation_Order_ErrorCode_NO_BRAND_ACCESS = 'Validation_Order_ErrorCode_NO_BRAND_ACCESS',
  Validation_Order_ErrorCode_NO_CATALOGUE_ERROR = 'Validation_Order_ErrorCode_NO_CATALOGUE_ERROR',
  Validation_Order_ErrorCode_NO_DEBTOR_ADDRESS = 'Validation_Order_ErrorCode_NO_DEBTOR_ADDRESS',
  Validation_Order_ErrorCode_NO_ERROR = 'Validation_Order_ErrorCode_NO_ERROR',
  Validation_Order_ErrorCode_NO_PRODUCTLINE_ACCESS = 'Validation_Order_ErrorCode_NO_PRODUCTLINE_ACCESS',
  Validation_Order_ErrorCode_NO_SALESMAN_FOUND = 'Validation_Order_ErrorCode_NO_SALESMAN_FOUND',
  Validation_Order_ErrorCode_NO_STARTER_BOX_BOUGHT = 'Validation_Order_ErrorCode_NO_STARTER_BOX_BOUGHT',
  Validation_Order_ErrorCode_NO_WEB_PRICE_ERROR = 'Validation_Order_ErrorCode_NO_WEB_PRICE_ERROR',
  Validation_Order_ErrorCode_OFFIC_SALES_PRICE_CHANGED = 'Validation_Order_ErrorCode_OFFIC_SALES_PRICE_CHANGED',
  Validation_Order_ErrorCode_ORDER_TOO_SMALL = 'Validation_Order_ErrorCode_ORDER_TOO_SMALL',
  Validation_Order_ErrorCode_ORDER_TOO_SMALL_Q = 'Validation_Order_ErrorCode_ORDER_TOO_SMALL_Q',
  Validation_Order_ErrorCode_PARSE_ERROR = 'Validation_Order_ErrorCode_PARSE_ERROR',
  Validation_Order_ErrorCode_INSUFFICIENT_STOCK_QUANTITY = 'Validation_Order_ErrorCode_INSUFFICIENT_STOCK_QUANTITY',
  Validation_Order_ErrorCode_DELIVERY_BLOCK = 'Validation_Order_ErrorCode_DELIVERY_BLOCK',
  Validation_Order_ErrorCode_NO_ATP_ORDER_LINE = 'Validation_Order_ErrorCode_NO_ATP_ORDER_LINE',
  Validation_Order_ErrorCode_NOOS_ORDER_LINE = 'Validation_Order_ErrorCode_NOOS_ORDER_LINE',
  Validation_Order_ErrorCode_SHIPTO_BLOCKED = 'Validation_Order_ErrorCode_SHIPTO_BLOCKED',
  Validation_Order_ErrorCode_SIZE_DDR_CONTROLLED = 'Validation_Order_ErrorCode_SIZE_DDR_CONTROLLED',
  Validation_Order_ErrorCode_INVALID_SALES_PRICE_ERROR = 'Validation_Order_ErrorCode_INVALID_SALES_PRICE_ERROR',
  Validation_Basket_Backend_Unavailable = 'Validation_Basket_Backend_Unavailable',
  Validation_Account_Suspended = 'Validation_Account_Suspended',
  Validation_Basket_QuantityNotDivisibleBy = 'Validation_Basket_QuantityNotDivisibleBy',
  Validation_Basket_InvalidShippingOption = 'Validation_Basket_InvalidShippingOption',
  Validation_Basket_Order_Scheduled = 'Validation_Basket_Order_Scheduled',
  Validation_Basket_MinimumOrderQuantityNotFulfilled = 'Validation_Basket_MinimumOrderQuantityNotFulfilled',
  Validation_Order_ErrorCode_QUANTITY_PARSE_ERROR = 'Validation_Order_ErrorCode_QUANTITY_PARSE_ERROR',
  Validation_Order_ErrorCode_USER_NOT_FOUND = 'Validation_Order_ErrorCode_USER_NOT_FOUND',
  Validation_Order_ErrorCode_NO_STOCK = 'Validation_Order_ErrorCode_NO_STOCK',
  Validation_Basket_Min_Now_Total_Value = 'Validation_Basket_Min_Now_Total_Value',
  Validation_Basket_Min_Future_Total_Value = 'Validation_Basket_Min_Future_Total_Value',
  Validation_Order_ErrorCode_NO_VALIDATE = 'Validation_Order_ErrorCode_NO_VALIDATE',
}
